import { FC } from "react";

import {
  MOBILE_OVERLAY_ROUTE_QUERY_PARAM,
  SECONDARY_OVERLAY_QUERY_PARAM,
} from "components/constants";
import { CloseButton, CloseButtonProps } from "mds/components/CloseButton";
import { useQueryParamsManager } from "utils/routing";

type CloseOverlayButtonProps = Omit<CloseButtonProps<"button">, "onClick">;

export const CloseOverlayButton: FC<CloseOverlayButtonProps> = ({ size = "s", ...props }) => {
  const { deleteQueryParams } = useQueryParamsManager();

  const onClose = () => {
    deleteQueryParams([SECONDARY_OVERLAY_QUERY_PARAM, MOBILE_OVERLAY_ROUTE_QUERY_PARAM]);
  };

  return <CloseButton eventName="Right Panel - Close" size={size} {...props} onClick={onClose} />;
};
